import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'
import { ConstellationCanvas } from '../shared/ConstellationCanvas'
import { OrbitalMark } from '../shared/OrbitalMark'

export default function CosmosSection() {
    const { t } = useTranslation()

    return (
        <SectionShell id="cosmos">
            <ConstellationCanvas
                className="cosmos-canvas"
            />

            <div className="cosmos-content">
                <div className="section-head">
                    <span className="section-num">02</span>
                    <span className="section-label">{t('cosmos.label')}</span>
                </div>

                <h2 className="display-h2 cosmos-headline">
                    {t('cosmos.headline')}
                </h2>
                <p className="display-body cosmos-sub">{t('cosmos.sub')}</p>

                <div className="cosmos-orbs">
                    <div className="cosmos-orb-item">
                        <OrbitalMark width={100} height={100} className="cosmos-sub-orb" />
                        <span className="cosmos-orb-label">{t('cosmos.orb1')}</span>
                    </div>
                    <div className="cosmos-orb-divider" aria-hidden="true" />
                    <div className="cosmos-orb-item">
                        <OrbitalMark width={100} height={100} className="cosmos-sub-orb" />
                        <span className="cosmos-orb-label">{t('cosmos.orb2')}</span>
                    </div>
                </div>
            </div>
        </SectionShell>
    )
}
